import { ConversationStatus } from 'generated-graphql/types';
import { completedStatuses } from 'modules/conversations/constants/statuses';

export enum SourcingConversationStatusFilter {
  REVIEW = 'REVIEW',
  CREATED = 'CREATED',
  ONGOING = 'ONGOING',
  OPTED_OUT = 'OPTED_OUT',
  QUEUED = 'QUEUED',
  CLOSED = 'CLOSED',
  NOT_DELIVERED = 'NOT_DELIVERED'
}

export const sourcingConversationStatusFilterOptions = [
  {
    value: SourcingConversationStatusFilter.REVIEW,
    label: 'Review'
  },
  {
    value: SourcingConversationStatusFilter.CREATED,
    label: 'Created'
  },
  {
    value: SourcingConversationStatusFilter.ONGOING,
    label: 'In progress'
  },
  {
    value: SourcingConversationStatusFilter.OPTED_OUT,
    label: 'Opted out'
  },
  {
    value: SourcingConversationStatusFilter.QUEUED,
    label: 'Queued'
  },
  {
    value: SourcingConversationStatusFilter.CLOSED,
    label: 'Closed'
  },
  {
    value: SourcingConversationStatusFilter.NOT_DELIVERED,
    label: 'Not delivered'
  }
];

export const getConversationStatusesFromFilter = (
  filterValue: SourcingConversationStatusFilter
): ConversationStatus[] => {
  switch (filterValue) {
    case SourcingConversationStatusFilter.REVIEW:
      return [];
    case SourcingConversationStatusFilter.CREATED:
      return [ConversationStatus.Created];
    case SourcingConversationStatusFilter.ONGOING:
      return [ConversationStatus.Ongoing];
    case SourcingConversationStatusFilter.OPTED_OUT:
      return [ConversationStatus.OptedOut];
    case SourcingConversationStatusFilter.QUEUED:
      return [ConversationStatus.Queued];
    case SourcingConversationStatusFilter.NOT_DELIVERED:
      return [ConversationStatus.DeliveryFailed];
    case SourcingConversationStatusFilter.CLOSED:
      return completedStatuses;
    default:
      return [];
  }
};
